import { axiosAjax } from '@app/src/config/axios';
import { hydrateOperator } from './hydrators';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

export const serviceOperator = {
  async getData(url: string, refreshToken?: string) {
    try {
      let token = refreshToken ? refreshToken : sessionStorage.getItem('accessToken');
      const idService = decodeAccessToken('idService');
      const { data } = await axiosAjax.get(url.replace(':id', idService.toString()), {
        headers: { Authorization: `Bearer ${token}` }
      });
      return hydrateOperator(data);
    } catch(e) {
      throw e.response.data;
    }
  }
};

export const serviceRefreshToken = {
  async getData(refreshToken: string) {
    try {
      const userId = decodeAccessToken('idUser');
      const expToken = sessionStorage.getItem('accessToken');
      const { data } = await axiosAjax.post(process.env.API_REFRESH_TOKEN, { userId, refreshToken, expToken});
      return data;
    } catch (e) {
      throw e.response.data;
    }
  }
}
